export { VariantInfoBlock } from "./variant-info-block";
export type { VariantInfoBlockProps } from "./variant-info-block";
